import NavbarAdmin from "../../components/NavbarAdmin";
import BannerSlider from "../../components/BannerSlider";
import Features from "../../components/Features";
import AboutSection from "../../components/AboutSection";
import WhyChoose from "../../components/WhyChoose";
import AksesSection from "../../components/AksesSection";
import Footer from "../../components/Footer";


export default function DashboardAdmin() {
  return (
    <div className="tk-landing">
      <NavbarAdmin />
      <BannerSlider />
      <Features />
      <AboutSection />
      <WhyChoose />
      <AksesSection />
      <Footer />
    </div>
  );
}